import { Component, inject } from '@angular/core';
import { MandantConfigService } from '@strategies/mandant-config.service';
import { BaseDynamicContainer } from '@strategies/_containers/base-dynamic.container';
import { UserActionsDefaultComponent } from '@strategies/_default/user-actions';

@Component({
  selector: 'user-actions',
  template: '<ng-template #dynamic></ng-template>',
  styleUrls: [],
  standalone: false,
})
export class UserActionsContainerComponent extends BaseDynamicContainer {
  mandantConfigService: MandantConfigService;

  constructor() {
    const mandantConfigService = inject(MandantConfigService);

    super(mandantConfigService);

    this.mandantConfigService = mandantConfigService;
  }

  protected override getComponent() {
    return this.viewContainerRef.createComponent(UserActionsDefaultComponent);
  }
}
